import { ReactNode } from 'react';

import { titleStyles } from '@gasbi/shared/web/components/Dialog/DialogTitleBasic';

import { Skeleton, Theme } from '@mui/joy';
import Chip, { ChipProps } from '@mui/joy/Chip';

export const getStylesMap = (theme: Theme) => {
  const dark = theme.palette.isDarkMode;

  return {
    green: {
      color: dark ? 'success.900' : 'success.700',
      bgcolor: dark ? 'success.400' : 'success.100',
    },
    yellow: {
      color: dark ? 'warning.900' : 'warning.700',
      bgcolor: dark ? 'warning.400' : 'warning.100',
    },
    red: {
      color: dark ? 'danger.900' : 'danger.700',
      bgcolor: dark ? 'danger.400' : 'danger.100',
    },
    grey: {
      color: dark ? 'neutral.900' : 'neutral.700',
      bgcolor: dark ? 'neutral.400' : 'neutral.200',
    },
    purple: {
      color: dark ? 'primary.900' : 'primary.500',
      bgcolor: dark ? 'primary.400' : 'primary.50',
    },
  };
};

export interface StatusChipProps extends Omit<ChipProps, 'color' | 'title'> {
  color: string; // 'green' | 'yellow' | 'red' | 'grey';
  title: ReactNode;
  loading?: boolean;
}

const StatusChip = ({
  color,
  title,
  loading = false,
  sx = {},
  ...props
}: StatusChipProps) => {
  return (
    <Chip
      sx={theme => ({
        ...getStylesMap(theme)[color],
        fontWeight: 500,
        ...titleStyles,
        width: '100%',
        ...sx,
      })}
      size='sm'
      slotProps={{ action: { sx: { '&, &:hover': { background: 'none' } } } }}
      {...props}
    >
      <Skeleton
        loading={!title && loading}
        variant='rectangular'
        sx={{ height: '15px', width: '95px', borderRadius: '8px' }}
      >
        {title}
      </Skeleton>
    </Chip>
  );
};

export default StatusChip;
